const cities = [
  'Mumbai',
  'Pune',
  'Nagpur',
  'Nashik',
  'Aurangabad',
  'Solapur',
  'Kolhapur',
  'Sangli',
  'Satara',
  'Ahmednagar',
  'Latur',
  'Osmanabad',
  'Beed',
  'Jalna',
  'Parbhani',
  'Nanded',
  'Hingoli',
  'Washim',
  'Akola',
  'Amravati',
  'Yavatmal',
  'Buldhana',
  'Wardha',
  'Chandrapur',
  'Gadchiroli',
  'Gondia',
  'Bhandara',
  'Jalgaon',
  'Dhule',
  'Nandurbar',
  'Ratnagiri',
  'Sindhudurg',
  'Raigad',
  'Thane',
  'Palghar',
  'Delhi',
  'Bangalore',
  'Hyderabad',
  'Chennai',
  'Ahmedabad',
  'Indore',
  'Bhopal',
  'Jaipur',
  'Lucknow',
  'Other',
];

export default cities;
